export const parseUrl = (url: string): URL | undefined => {
  try {
    return new URL(url);
  } catch {}
};
